import { ShoesState } from 'src/types'

export const gripTop = (ctx: CanvasRenderingContext2D | null, x: number, y: number) => {
  ctx.strokeStyle = '#1c1c1c'
  ctx.lineWidth = 2.0
  ctx.fillStyle = '#1c1c1c'
  ctx.beginPath()
  ctx.moveTo(22, 465) //つま先＿左下
  ctx.quadraticCurveTo(23, 483, 23, 480)
  ctx.quadraticCurveTo(53, 505, 119, 521)
  ctx.quadraticCurveTo(137, 526, 137, 523)
  ctx.quadraticCurveTo(136, 519, 136, 519)
  ctx.quadraticCurveTo(133, 512, 119, 514)
  ctx.quadraticCurveTo(109, 499, 109, 499)
  ctx.quadraticCurveTo(43, 483, 22, 465)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const gripMiddle = (ctx: CanvasRenderingContext2D | null, x: number, y: number) => {
  ctx.strokeStyle = '#1c1c1c'
  ctx.lineWidth = 1.0
  // ctx.fillStyle = '#1c1c1c'
  ctx.beginPath()
  ctx.moveTo(136, 520) //つま先＿左下
  ctx.quadraticCurveTo(137, 527, 137, 525)
  ctx.quadraticCurveTo(204, 546, 245, 545)
  ctx.quadraticCurveTo(340, 560, 385, 543)
  ctx.quadraticCurveTo(376, 542, 376, 542)
  ctx.quadraticCurveTo(356, 551, 346, 541)
  ctx.quadraticCurveTo(258, 534, 258, 534)
  ctx.quadraticCurveTo(248, 534, 246, 541)
  ctx.quadraticCurveTo(237, 530, 227, 539)
  ctx.quadraticCurveTo(221, 527, 221, 527)
  ctx.quadraticCurveTo(181, 523, 153, 512)
  ctx.quadraticCurveTo(137, 505, 136, 520)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const gripRightBack = (ctx: CanvasRenderingContext2D | null, x: number, y: number) => {
  ctx.strokeStyle = '#1c1c1c'
  ctx.lineWidth = 1.0
  ctx.fillStyle = '#1c1c1c'
  ctx.beginPath()
  ctx.moveTo(382 + x, 544 + y) //つま先＿左下
  ctx.quadraticCurveTo(387 + x, 547 + y, 387 + x, 547 + y)
  ctx.quadraticCurveTo(445 + x, 550 + y, 499 + x, 547 + y)
  ctx.quadraticCurveTo(501 + x, 554 + y, 501 + x, 554 + y)
  ctx.quadraticCurveTo(591 + x, 551 + y, 591 + x, 551 + y)
  ctx.quadraticCurveTo(592 + x, 540 + y, 592 + x, 540 + y)
  ctx.quadraticCurveTo(496 + x, 542 + y, 460 + x, 538 + y)
  ctx.quadraticCurveTo(451 + x, 542 + y, 439 + x, 538 + y)
  ctx.quadraticCurveTo(427 + x, 544 + y, 411 + x, 538 + y)
  ctx.quadraticCurveTo(401 + x, 542 + y, 382 + x, 544 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  // ctx.moveTo()
  ctx.stroke()
  ctx.closePath()

  // ctx.beginPath()
  // ctx.fillStyle = '#1c1c1c'
  // ctx.moveTo(543 + x, 551 + y)
  // ctx.quadraticCurveTo(542 + x, 562 + y, 542 + x, 562 + y)
  // ctx.quadraticCurveTo(547 + x, 563 + y, 547 + x, 563 + y)
  // ctx.quadraticCurveTo(547 + x, 552 + y, 547 + x, 552 + y)
  // ctx.quadraticCurveTo(543 + x, 551 + y, 543 + x, 551 + y)
  // // ctx.quadraticCurveTo()

  // ctx.stroke()
  // ctx.fill()
  // ctx.closePath()
}

export const gripHeal = (ctx: CanvasRenderingContext2D | null, x: number, y: number) => {
  ctx.strokeStyle = '#1c1c1c'
  ctx.lineWidth = 2.0
  ctx.fillStyle = '#1c1c1c'
  ctx.beginPath()
  ctx.moveTo(606 + x, 580 + y) //つま先＿左下
  ctx.quadraticCurveTo(642 + x, 582 + y, 688 + x, 581 + y)
  ctx.quadraticCurveTo(690 + x, 577 + y, 694 + x, 581 + y)
  ctx.quadraticCurveTo(734 + x, 589 + y, 771 + x, 585 + y)
  ctx.quadraticCurveTo(798 + x, 593 + y, 829 + x, 587 + y)
  ctx.quadraticCurveTo(832 + x, 575 + y, 836 + x, 577 + y)
  ctx.quadraticCurveTo(853 + x, 574 + y, 854 + x, 563 + y)
  ctx.quadraticCurveTo(829 + x, 578 + y, 788 + x, 575 + y)
  ctx.quadraticCurveTo(782 + x, 568 + y, 772 + x, 574 + y)
  ctx.quadraticCurveTo(612 + x, 566 + y, 612 + x, 566 + y)
  ctx.quadraticCurveTo(605 + x, 562 + y, 606 + x, 580 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.fillStyle = '#1c1c1c'
  ctx.moveTo(685 + x, 569 + y)
  ctx.quadraticCurveTo(687 + x, 580 + y, 687 + x, 580 + y)
  ctx.quadraticCurveTo(693 + x, 580 + y, 693 + x, 580 + y)
  ctx.quadraticCurveTo(692 + x, 569 + y, 692 + x, 569 + y)
  ctx.quadraticCurveTo(685 + x, 569 + y, 685 + x, 569 + y)
  ctx.fill()
  // ctx.stroke()

  ctx.moveTo(772 + x, 575 + y)
  ctx.quadraticCurveTo(772 + x, 584 + y, 772 + x, 584 + y)
  ctx.quadraticCurveTo(786 + x, 588 + y, 786 + x, 588 + y)
  ctx.quadraticCurveTo(787 + x, 576 + y, 787 + x, 576 + y)
  ctx.quadraticCurveTo(781 + x, 567 + y, 772 + x, 575 + y)
  ctx.fill()

  ctx.closePath()
}

export const gripToe = (ctx: CanvasRenderingContext2D | null, x: number, y: number) => {
  ctx.strokeStyle = '#1c1c1c'
  ctx.lineWidth = 1.0
  ctx.fillStyle = '#1c1c1c'
  ctx.beginPath()
  ctx.moveTo(11, 400) //つま先＿左下
  ctx.quadraticCurveTo(-8, 435, 8, 461)
  ctx.quadraticCurveTo(20, 475, 20, 475)
  ctx.quadraticCurveTo(19, 462, 19, 462)
  ctx.quadraticCurveTo(11, 445, 18, 434)
  ctx.quadraticCurveTo(28, 436, 28, 436)
  ctx.quadraticCurveTo(37, 430, 31, 421)
  ctx.quadraticCurveTo(22, 406, 11, 400)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const gripWarts = (ctx: CanvasRenderingContext2D | null, x: number, y: number) => {
  ctx.strokeStyle = '#1c1c1c'
  ctx.lineWidth = 1.0
  ctx.fillStyle = 'black'
  ctx.beginPath()
  ctx.moveTo(25 + x, 479 + y) //つま先＿左下
  ctx.quadraticCurveTo(25 + x, 485 + y, 25 + x, 485 + y)
  ctx.quadraticCurveTo(30 + x, 490 + y, 37 + x, 489 + y)
  ctx.quadraticCurveTo(39 + x, 486 + y, 39 + x, 486 + y)
  ctx.quadraticCurveTo(31 + x, 479 + y, 25 + x, 479 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// const gripHeal = (ctx: CanvasRenderingContext2D | null, x: number, y: number) => {
//   ctx.strokeStyle = 'red' // '#1c1c1c'
//   ctx.lineWidth = 2.0
//   // ctx.fillStyle = '#1c1c1c'
//   ctx.beginPath()
//   ctx.moveTo(22, 465) //つま先＿左下
//   // ctx.quadraticCurveTo()
//   // ctx.quadraticCurveTo()
//   // ctx.quadraticCurveTo()
//   // ctx.fill()
//   ctx.stroke()
//   ctx.closePath()
// }

export const runningShoesSole = (ctx: CanvasRenderingContext2D | null, state: ShoesState) => {
  ctx.save()
  // const rotateX = 0
  // const rotateY = 0
  ctx.rotate(0)
  ctx.strokeStyle = '#1c1c1c'
  ctx.fillStyle = 'white'
  ctx.beginPath()
  ctx.moveTo(10, 431) //つま先＿左下
  ctx.quadraticCurveTo(5, 443, 13, 458)
  ctx.quadraticCurveTo(47, 480, 109, 499)
  ctx.quadraticCurveTo(119, 513, 119, 513)
  ctx.quadraticCurveTo(131, 512, 137, 518)
  ctx.quadraticCurveTo(136, 509, 149, 511)
  ctx.quadraticCurveTo(166, 520, 221, 529)
  ctx.quadraticCurveTo(227, 540, 227, 540)
  ctx.quadraticCurveTo(240, 530, 246, 543)
  ctx.quadraticCurveTo(249, 532, 268, 535)
  ctx.quadraticCurveTo(348, 543, 348, 543)
  ctx.quadraticCurveTo(358, 550, 377, 543)
  ctx.quadraticCurveTo(386, 545, 411, 538)
  ctx.quadraticCurveTo(431, 544, 438, 538)
  ctx.quadraticCurveTo(449, 541, 465, 540)
  ctx.quadraticCurveTo(499, 545, 499, 545)
  ctx.quadraticCurveTo(593, 540, 593, 540)
  ctx.quadraticCurveTo(603, 536, 613, 543)
  ctx.quadraticCurveTo(772, 544, 772, 544)
  ctx.quadraticCurveTo(784, 540, 790, 545)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.quadraticCurveTo(826, 548, 853, 533) // 右下
  ctx.quadraticCurveTo(855, 517, 855, 517)
  ctx.quadraticCurveTo(850, 507, 857, 502)
  ctx.quadraticCurveTo(861, 500, 857, 493)
  // ctx.quadraticCurveTo(854, 487, 855, 481)
  ctx.quadraticCurveTo(849, 483, 855, 478) // 右上
  ctx.quadraticCurveTo(845, 476, 841, 476)
  ctx.quadraticCurveTo(702, 497, 548, 488)
  ctx.quadraticCurveTo(449, 486, 391, 500)
  ctx.quadraticCurveTo(280, 520, 203, 500)
  ctx.quadraticCurveTo(89, 478, 10, 431)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#1c1c1c'

  ctx.lineWidth = 2.0
  ctx.beginPath()
  ctx.moveTo(15, 447) //
  ctx.quadraticCurveTo(110, 500, 225, 519)
  ctx.quadraticCurveTo(304, 534, 368, 515)
  ctx.quadraticCurveTo(396, 501, 451, 497)
  ctx.stroke()

  ctx.lineWidth = 1.5
  ctx.moveTo(404, 540)
  ctx.quadraticCurveTo(432, 511, 480, 495)
  ctx.quadraticCurveTo(543, 489, 597, 498)
  ctx.moveTo(429, 541)
  ctx.quadraticCurveTo(460, 489, 578, 507)
  ctx.moveTo(458, 540)
  ctx.quadraticCurveTo(485, 499, 560, 514)

  ctx.moveTo(583, 497)
  ctx.quadraticCurveTo(729, 507, 853, 484)

  ctx.lineWidth = 0.8
  ctx.moveTo(582, 505)
  ctx.quadraticCurveTo(699, 520, 858, 502)
  ctx.moveTo(582, 515)
  ctx.quadraticCurveTo(683, 539, 854, 519)

  ctx.stroke()
  ctx.closePath()

  gripTop(ctx, 0, 0)
  gripMiddle(ctx, 0, 0)

  gripRightBack(ctx, 0, -3)
  gripHeal(ctx, 0, -30)

  // gripToe(ctx, 0, 0)
  // gripWarts(ctx, 0, 0)
  // gripWarts(ctx, 15, 9)
  // gripWarts(ctx, 30, 16)
  // gripWarts(ctx, 45, 23)
  // gripWarts(ctx, 63, 29)
  // gripWarts(ctx, 80, 34)

  // gripWarts(ctx, 114, 42)
  // gripWarts(ctx, 133, 48)
  // gripWarts(ctx, 157, 53)
  // gripWarts(ctx, 178, 56)

  // gripWarts(ctx, 225, 60)
  // gripWarts(ctx, 250, 63)
  // gripWarts(ctx, 275, 64)
  // gripWarts(ctx, 300, 65)

  ctx.restore()
}
